module.exports = "/images/vendor/vue-image-lightbox-carousel/src/loading.gif?fd42f6cbf2d662175f36d84895fdfba5";